import { TAGS_URL } from '@/modules/tag/tag.constants';
import { resolveCurrentUser } from '@/modules/user/user.service';
import { createEmptyComponent } from '@/router/route.service';

export default [
  {
    path: TAGS_URL.path,
    redirect: '/',
    beforeEnter: resolveCurrentUser,
    component: { render: createEmptyComponent },
    children: [
      {
        ...TAGS_URL.view,
        component: () => import('@/modules/tag/views/TagViewPage.vue'),
      },
    ],
  },
];

export function goToOpenTag($router, tag) {
  $router.push({
    name: TAGS_URL.view.name,
    params: { id: tag.id },
  });
}
